module.exports = __webpack_public_path__ + "img/40_00_080_282.5f8f0e99.jpg";